/**
 * This is a local development file only.
 * It should only be committed if a new property is added
 *
 * PRIOR TO EDITTING
 * run `git update-index --assume-unchanged <pathToFile>/log-config.js
 * This will ignore changes to this file so they will not be committed
 */
export default {
    strictMode: true,
    shouldLogAll: true, // should all actions be logged
    excludedActions: [], // list of specific actions to always be excluded
};
